import axiosInstanceNew from "../lib/axiosinstanceNew";

const CallbackModel=class {

    constructor(){
        this.baseUrl="callback_requests";
        // Dummy data for callback requests
        this.dummyData = [
            {
                _id: "1",
                id: "1",
                auth_user: {
                    first_name: "Rajesh",
                    last_name: "Kumar",
                    username: "9876543210"
                },
                status: "Pending",
                created_at: "2024-01-15T10:30:00Z",
                message: "Need help with mathematics tutoring"
            },
            {
                _id: "2",
                id: "2",
                auth_user: {
                    first_name: "Priya",
                    last_name: "Sharma",
                    username: "9876543211"
                },
                status: "Completed",
                created_at: "2024-01-16T14:20:00Z",
                message: "Looking for physics tutor for class 12"
            },
            {
                _id: "3",
                id: "3",
                auth_user: {
                    first_name: "Amit",
                    last_name: "Verma",
                    username: "9876543212"
                },
                status: "In Progress",
                created_at: "2024-01-17T09:15:00Z",
                message: "Chemistry tutor required urgently"
            },
            {
                _id: "4",
                id: "4",
                auth_user: {
                    first_name: "Sunita",
                    last_name: "Gupta",
                    username: "9876543213"
                },
                status: "Pending",
                created_at: "2024-01-18T16:45:00Z",
                message: "English tutor for competitive exams"
            },
            {
                _id: "5",
                id: "5",
                auth_user: {
                    first_name: "Vikash",
                    last_name: "Singh",
                    username: "9876543214"
                },
                status: "Completed",
                created_at: "2024-01-19T11:30:00Z",
                message: "Biology tutor for NEET preparation"
            }
        ];
    }
    async get()
    {
        // Return dummy data instead of API call
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: this.dummyData,
                    meta: {
                        current_page: 1,
                        per_page: 20,
                        total: this.dummyData.length
                    }
                });
            }, 1000);
        });
    }
    async Mark(id, data = []) {
        // Simulate marking a callback request
        return new Promise((resolve) => {
            setTimeout(() => {
                const index = this.dummyData.findIndex(item => item.id === id);
                if (index !== -1) {
                    this.dummyData[index].status = "Completed";
                }
                resolve({
                    success: true,
                    message: "Request marked successfully"
                });
            }, 500);
        });
    }
    async Delete(id) {
        // Simulate deleting a callback request
        return new Promise((resolve) => {
            setTimeout(() => {
                const index = this.dummyData.findIndex(item => item.id === id);
                if (index !== -1) {
                    this.dummyData.splice(index, 1);
                }
                resolve({
                    success: true,
                    message: "Request deleted successfully"
                });
            }, 500);
        });
    }
}

export default new CallbackModel();